import Header from "./component/Header/Header";
import Banner from "./component/Banner/Banner";
import TopHead from "./component/Top-head/TopHead";
import Partner from "./component/Partner/Partner";
import WeAre from "./component/We-are/We-are";
import Project from "./component/Project/Project";
import Procedure from "./component/Procedure/Procedure";
import Technology from "./component/Technology/Technology";
import FeedBack from "./component/Feed-Back/FeedBack";
import Staff from "./component/Staff/Staff";
import Contact from "./component/Contact/Contact";
import Footer from "./component/Footer/News/Footer/Footer";
import footer_pc from "../src/assets/images/footer_pc.webp";
import { Outlet } from "react-router-dom";
import Home from "./component/Home/Home";
import { SnackbarProvider } from "notistack";
import ConactsWidget from "./component/Contact-widget/Contact-widget";
import { Divider } from "@mui/material";
function App() {
  return (
    <SnackbarProvider>
      <div className="w-full md:pb-36 lg:pb-0 overflow-hidden">
        <div className="fixed z-[200] w-full">
          <TopHead />
          <Header />
          <Divider />
        </div>
        <div>
          <Outlet />
        </div>
        <Footer />
        <ConactsWidget />
      </div>
    </SnackbarProvider>
  );
}

export default App;
